<template>
  <div>
    <van-nav-bar
      title="委托查询"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/members')"
  
    />
    <div class="" style="font-size: 13px">
      <van-row class="dateFilter"
        ><van-col span="4" class="rowStyle"><span>委托日期:</span></van-col>
        <van-col span="7" class="rowStyle calanderStyle">
          <van-cell-group>
            <van-cell
              :value="startDate"
              @click="startStatus = true"
              style="padding: 1px; padding-left: 15px"
            />
            <van-popup v-model="startStatus" position="bottom">
              <van-datetime-picker
                v-model="date"
                @confirm="onConfirmStartDate"
                @cancel="startStatus = false"
                type="date"
                title="选择年月日"
              />
            </van-popup> </van-cell-group
        ></van-col>
        <van-col span="1" class="rowStyle" style="text-align: center"
          ><span>--</span></van-col
        >
        <van-col span="7" class="rowStyle calanderStyle">
          <van-cell-group>
            <van-cell
              :value="endDate"
              @click="endStatus = true"
              style="padding: 1px; padding-left: 15px"
            />
            <van-popup v-model="endStatus" position="bottom">
              <van-datetime-picker
                v-model="date"
                @confirm="onConfirmEndDate"
                @cancel="endStatus = false"
                type="date"
                title="选择年月日"
              />
            </van-popup> </van-cell-group
        ></van-col>
        <van-col span="5" class="rowStyleBtn" style="text-align: center"
          ><van-button
            size="small"
            style="height: 30px; background-color: #D02E27; border: 1px solid #D02E27; color:white"
            @click="getEntrust"
            >查询</van-button
          ></van-col
        >
      </van-row>
      <van-row class="tableheadings"
        ><van-col span="3" class="rowStyle"
          ><p>股票</p>
          <p>代码</p></van-col
        >
        <van-col span="5" class="rowStyle"
          ><p>委托价格</p>
          <p>成交价格</p></van-col
        >
        <van-col span="5" class="rowStyle" style="text-align: center"
          ><p>委托数量</p>
          <p>成交数量</p></van-col
        >
        <van-col span="3" class="rowStyle"
          ><p>买卖</p>
          <p>状态</p></van-col
        >
        <van-col span="8"
          ><p>委托时间</p>
          <p>成交时间</p></van-col
        >
      </van-row>
    </div>
    <van-list
      v-model="loadingEntrust"
      :finished="finishedEntrust"
      finished-text="没有更多了"
    >
      <div class="tabledata">
        <van-row
          class="rowData"
          v-for="(item, index) in entrustData.entrust"
          :key="index"
          ><van-col span="4" class="rowStyle"
            ><p>{{ item.name }}</p>
            <p>{{ item.code }}</p></van-col
          >
          <van-col span="4" class="rowStyle"
            ><p>{{ item.deal }}</p>
            <p>{{ item.price }}</p></van-col
          >
          <van-col span="4" class="rowStyle" style="text-align: center"
            ><p>{{ item.number }}</p>
            <p>{{ item.finish }}</p></van-col
          >
          <van-col span="4" class="rowStyle"
            ><p>{{ item.type }}</p>
            <p>{{ item.status }}</p></van-col
          >
          <van-col span="8"
            ><p>{{ item.time }} {{ item.accurate }}</p>
            <p>{{ item.complete_time }}</p></van-col
          >
        </van-row>
        <div style="margin-top: 25px; margin-bottom: 25px; color: #D02E27; font-weight: bold;text-align: center;">
          只显示最近12个月记录
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
export default {
  name: "EntrustInquiry",
  data() {
    return {
      entrustData: {
        date: [],
        entrust: [],
      },
      loadingEntrust: false,
      finishedEntrust: false,
      date: new Date(),
      startStatus: false,
      startDate: this.$moment().format("YYYY-MM-DD"),
      endStatus: false,
      endDate: this.$moment().format("YYYY-MM-DD"),
    };
  },
  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    getEntrust() {
      let that = this;
      that.loadingEntrust = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "all_entrust",
            token: window.sessionStorage.getItem("token"),
            start: that.startDate,
            end: that.endDate,
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code == 1) {
            let entrust = resData.data;
            let unwindData = [];
            for (let i = 0, len = entrust.length; i < len; i++) {
              if (entrust[i].depot_mold === 1) {
                unwindData.push(entrust[i]);
              }
            }
            that.unwindData = unwindData;
            that.entrustData.entrust = entrust;
            that.loadingEntrust = false;
            that.finishedEntrust = true;
          } else if (resData.code == 0 || resData.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          that.loadingEntrust = false;
          that.finishedEntrust = true;
          that.$toast.fail(that.$NoNetworkErrorMsg);
        });
    },
    onConfirmStartDate(time) {
      this.startDate = this.$moment(time).format("YYYY-MM-DD");
      this.startStatus = false;
    },
    onConfirmEndDate(time) {
      this.endDate = this.$moment(time).format("YYYY-MM-DD");
      this.endStatus = false;
    },
  },
  mounted: function () {
    let that = this;
    that.isLogin();
    that.getEntrust();
  },
};
</script>

<style scoped>
.navstyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.topContent {
  height: 130px;
  background: #ffffff;
  position: fixed;
  top: 42px;
  left: 0;
  width: 100%;
}

.dateFilter {
  padding: 10px 5px;
  /* position: fixed;
  top: 56px;
  left: 0;
  width: 100%; */
  border-bottom: 1px solid #ebedf0;
}

.rowStyle {
  height: 30px;
  line-height: 30px;
}

.calanderStyle {
  border: 1px solid #969799;
}

.rowStyleBtn {
  line-height: 20px;
}

.tableheadings {
  /* padding: 0px 5px; */
  /* position: fixed;
  top: 115px;
  left: 0;
  width: 100%; */
  border-bottom: 1px solid #ebedf0;
  padding: 10px 0px;
  text-align: center;
}

.tableheadings p {
  line-height: 20px;
  margin: 0;
}

.tabledata {
  /* padding: 0px 5px; */
  margin-top: 10px;
  padding-bottom: 10px;
  text-align: center;
}

.tabledata p {
  line-height: 20px;
  margin: 0;
  font-size: 12px;
}

.rowData {
  border-bottom: 1px solid rgb(235, 237, 240);
  padding: 10px 0px;
}
</style>

<style>
</style>



// WEBPACK FOOTER //
// src/components/EntrustInquiry.vue